import { doc, getDoc, collection, addDoc, updateDoc } from 'firebase/firestore';
import { Database } from '../firebase/index';
import { firestoreErrorHandler } from '../helper/errorParser';

/**
 * Membaca satu dokumen dari koleksi Firestore (sekali baca)
 * @param {string} collectionName - nama koleksi (contoh: 'userSessions')
 * @param {string} document - ID dokumen yang ingin dibaca
 * @returns {Promise<{data: object|null, message: string}>}
 */
export async function readDocumentOnce(collectionName, document) {
	try {
		if (
			typeof collectionName !== 'string' ||
			!collectionName.trim() ||
			typeof document !== 'string' ||
			!document.trim()
		) {
			return firestoreErrorHandler({ code: 'invalid-argument' });
		}

		const docRef = doc(Database, collectionName, document);
		const docSnap = await getDoc(docRef);

		if (!docSnap.exists()) {
			return firestoreErrorHandler({ code: 'data-not-exist' });
		}

		return { data: docSnap.data(), message: 'success' };
	} catch (error) {
		console.error(error);
		return firestoreErrorHandler(error);
	}
}

/**
 * Menambahkan dokumen baru ke koleksi Firestore
 * @param {string} collectionName - nama koleksi (contoh: 'userSessions')
 * @param {object} data - data dokumen yang ingin ditambahkan
 * @returns {Promise<{data: import('firebase/firestore').DocumentReference|null, message: string}>}
 */
export const addDocument = async (collectionName, data) => {
	try {
		const docRef = await addDoc(collection(Database, collectionName), data);

		return { data: docRef, message: 'success' };
	} catch (e) {
		console.error(e);
		return { data: null, message: 'failed' };
	}
};

/**
 * Update satu dokumen Firestore
 * @param {string} collectionName - nama koleksi (misal: 'userSessions')
 * @param {string} documentId - ID dokumen yang ingin di-update
 * @param {object} data - data yang ingin di-update (partial fields)
 * @returns {Promise<{message: string}>}
 */
export const updateDocument = async (collectionName, documentId, data) => {
	try {
		const docRef = doc(Database, collectionName, documentId);
		await updateDoc(docRef, data);
		return { message: 'success' };
	} catch (error) {
		console.error('Firestore update error:', error);
		return firestoreErrorHandler(error);
	}
};
